export var SENTRY_RELEASE = "3180bbc948efdb1bd6a561189764fc6dc1ce232b";
